export const PREBUILT_LAYOUTS_PLUGIN_ID = 'PrebuiltLayouts';
